// Purpose: Lightweight global event bus for player seek requests.
// Audience: Components needing to request video seek without tight coupling.
// Interplay: Results views dispatch seek events; EvidenceModal subscribes.
// Simple global event bus for player seeking

const bus = new EventTarget();

export const playerBus = {
  requestSeek: (seconds) => {
    try {
      bus.dispatchEvent(new CustomEvent('seek', { detail: Number(seconds) || 0 }));
    } catch (_) {}
  },
  onSeek: (handler) => {
    const listener = (e) => handler(e.detail);
    bus.addEventListener('seek', listener);
    return () => bus.removeEventListener('seek', listener);
  }
};


